import React, { useState, useEffect } from "react";
import FuelReportInfo from "./FuelReportInfo";


function PeriodSelector(props) {
    // useEffect(() => {
    //     console.log(props);
    // }, []);

    return (
        <FuelReportInfo handleDataGroup={props.handleDataGroup} selectedGroup={props.selectedGroup} callFuelData={props.callFuelData}
            handleOnChange={props.handlePeriodChange} device={props.device} loading={props.loading} selectedValue={props.selectedValue}
            hasFuelSensor={props.hasFuelSensor} assetDeviceDailyFuelDataSuccess={props.assetDeviceDailyFuelDataSuccess}
            processDeviceDailyFuelDataInPeriod={props.processDeviceDailyFuelDataInPeriod} />
    );
}


export default PeriodSelector;